export default __webpack_public_path__ + "assets/indus-ind.svg";